import ApiService from '../../services/api.service';
import MedialibraryModel from '../medialibrary/medialibrary-model';
import OwnerModel from '../owner/owner-model';

export default class ReportModel {
    id: number;
    name: string;
    description: string;
    status: string;
    owner: any;
    ownerCaption: string;
    parent: any;
    parentCaption: string;
    report: any;
    reportLength: number;
    title: string;
    content: string;
    seq: number;
    type: string;
    typeCaption: string;
    option: any;
    image: any;
    imageId: number;
    imageUrl: string;
    imagetitle: string;
    
    constructor(datarow:any) {
        if (datarow.attributes) datarow = {...datarow.attributes, id: datarow.id}
        this.id = datarow.id;
        this.name = datarow.name;
        this.description = datarow.description;
        this.status = datarow.status || 'active';
        let owner = datarow.owner?.data? new OwnerModel(datarow.owner?.data) : datarow.owner;
        this.owner = owner?.id;
        this.ownerCaption = owner?.name;
        let parent= datarow.parent?.data? new ReportModel(datarow.parent?.data) : datarow.parent;
        this.parent= parent?.id;
        this.parentCaption = parent?.name;
        this.report = datarow.report?.data?.map((d: any) => new ReportModel(d));
        this.reportLength = this.report?.length || 0;
        this.title = datarow.title;
        this.content = datarow.content;
        this.seq = datarow.seq;
        this.type = datarow.type || 'general' || 'sectiongeneral';
        this.typeCaption = (ReportModel.optionType, ReportModel.optionTypeSection).filter((d: any) => d.name === this.type)?.[0]?.caption || 'General';
        this.option = datarow.option || (!this.parent && ReportModel.option[this.type]);
        this.image = datarow.image?.data?.map((d: any) => new MedialibraryModel(d))?.[0];
        this.imageId = this.image?.id;
        this.imageUrl = this.image? ((this.image.url?.startsWith('http')? '' : ApiService.svrUrl) + this.image.url) : '';                
        this.imagetitle = datarow.imagetitle;
        
    } 

    public static endPoint: string = 'reports';
    public static endPointMedia: string = 'api::report.report';
    public static endPointFilter2: string = '?populate[report][populate]=image&populate[report][sort]=seq&filters[id]=';
    public static endPointFilterList = (parentId?: number, reportgroupId?: number) => {
        const owner = OwnerModel.getOwner();
        
        return ( '?populate=*&sort=name&&filters[owner]=' + owner +
            (reportgroupId? '&filters[reportgroup]=' + reportgroupId :
                '&filters[parent]' + (parentId? '=' + parentId : '[id][$null]=true')
            )
        );
    }
    public static url: string = '/report';
    public static caption: string = 'Report';

    public static defaultValue = () => {
        return {
        id: 0,
        name: '',
        description: '',
        status: 'active',
        owner: +OwnerModel.getOwner(),
        ownerCaption: OwnerModel.getOwnerCaption(),   
        parent: null,
        parentCaption: '',
        report: [],
        reportLength: 0,
        title: '',
        content: '',
        seq: 0,
        type: '',
        typeCaption: '',
        option: this.option.general,
        image: null,
        imageId: 0,
        imageUrl: '',
        imagetitle: '',
        }
    }
    
    public static validations = [
        { name: 'name', required: true, minLength: 3 },
        { name: 'description', minLength: 3 },
    ]

    public static columns = [
        { name: 'name', caption: 'Name' },
        { name: 'description', caption: 'Description' },
        { name: 'typeCaption', caption: 'Type' },
        { name: 'status', caption: ' ', type: 'state', default: 'active' },
    ]

    public static columnPicklist = [
        { name: 'name', caption: 'Name' },
        { name: 'title', caption: 'Title' },
    ]

    public static optionStatus = [
        { name: 'active', caption: 'Active' },
        { name: 'inactive', caption: 'Inactive' },
    ]
        
    public static optionType = [
        { name: 'general', caption: 'General' },
        { name: 'invitation', caption: 'Invitation' },
        { name: 'invoice', caption: 'Invoice' },
        { name: 'page', caption: 'Page' },
    ]
    
    public static optionTypeSection = [
        { name: 'sectioncover', caption: 'Section Cover' },
        { name: 'sectionheader', caption: 'Section Header' },
        { name: 'sectionbody', caption: 'Section Body' },
        { name: 'sectionfooter', caption: 'Section Footer' },
        { name: 'sectiongallery', caption: 'Section Gallery' },
    ]
    
    public static printOption : any = {
        printOption: {
            type: 'pdf',
            fileName: '[filename]',
            fileType: 'a4',
            fileProperties: { title: '[reportname]', subject: '[reportname] - [fullname]', author: '[documenttitle]', keywords: '[reportdescription]', creator: '[documenttitle]' },
            margin: 20,
            marginAdj: [{ pageNumber: 1, value: 0 }],
            headerText: { start: 0, left: '', center: '', right: '' },
            footerText: { start: 2, left: 'Confidential Report', center: 'Page [pagenumber]', right: '[fullname]' },
        },
    }
    public static option : any = {
        general: {
            ...this.printOption,
            sectionbody: { 
                frame: {paddingTop: {xs: 1, md: 2}, paddingBottom: {xs: 1, md: 2}},
                image: {justifyContent:'center', marginTop: {xs: 5, md: 10}, marginBottom: {xs: 5, md: 10}},
                imagetitle: {
                    frame: {justifyContent:'center', paddingBottom: {xs: 1, md: 1}},
                    typography: {typography: {xs: 'caption', md: 'h6'}, textAlign: 'center'},
                },
                title: {
                    frame: {justifyContent:'center', paddingBottom: {xs: 1, md: 2}},
                    typography: {typography: {xs: 'subtitle1', md: 'h5'}, textAlign: 'center'},
                },
                content: {
                    frame: {justifyContent:'center', paddingBottom: {xs: 1, md: 2}},
                    typography: {typography: {xs: 'caption', md: 'h6'}, textAlign: 'justify'},
                },
            },

            sectioncover: { 
                frame: {paddingTop: {xs: 1, md: 2}, paddingBottom: {xs: 1, md: 2}},
                imagetitle: {
                    frame: {justifyContent:'right'},
                    typography: {typography: {xs: 'body2', md: 'h5'}, textAlign: 'center', color: 'navy', border: {xs: 2, md: 3}, padding: {xs: 1, md: 2}},
                },
                image: {justifyContent:'center', marginTop: {xs: 15, md: 25}, marginBottom: {xs: 15, md: 25}},
                title: {
                    frame: {justifyContent:'center', paddingBottom: {xs: 1, md: 2}},
                    typography: {typography: {xs: 'subtitle1', md: 'h4'}, textAlign: 'center'},
                },
                content: {
                    frame: {justifyContent:'center', paddingBottom: {xs: 1, md: 2}},
                    typography: {typography: {xs: 'caption', md: 'h6'}, textAlign: 'center'},
                },
            },

            sectionheader: { 
                frame: {paddingTop: {xs: 1, md: 2}, paddingBottom: {xs: 1, md: 2}},
                image: {justifyContent:'center', marginTop: {xs: 5, md: 10}, marginBottom: {xs: 5, md: 10}},
                imagetitle: {
                    frame: {justifyContent:'center', paddingBottom: {xs: 1, md: 1}},
                    typography: {typography: {xs: 'caption', md: 'h6'}, textAlign: 'center'},
                },
                title: {
                    frame: {justifyContent:'center', paddingBottom: {xs: 10, md: 20}},
                    typography: {typography: {xs: 'subtitle1', md: 'h5'}, textAlign: 'center'},
                },
                content: {
                    frame: {justifyContent:'center', paddingBottom: {xs: 1, md: 2}},
                    typography: {typography: {xs: 'caption', md: 'h6'}, textAlign: 'justify'},
                },
            },

            sectionfooter: { 
                frame: {paddingTop: {xs: 1, md: 2}, paddingBottom: {xs: 1, md: 2}},
                image: {justifyContent:'center', marginTop: {xs: 20, md: 40}, marginBottom: {xs: 10, md: 20}},
                imagetitle: {
                    frame: {justifyContent:'center', paddingBottom: {xs: 1, md: 1}},
                    typography: {typography: {xs: 'caption', md: 'h6'}, textAlign: 'center'},
                },
                title: {
                    frame: {justifyContent:'center', paddingBottom: {xs: 10, md: 20}},
                    typography: {typography: {xs: 'subtitle1', md: 'h5'}, textAlign: 'center'},
                },
                content: {
                    frame: {justifyContent:'center', paddingBottom: {xs: 1, md: 2}},
                    typography: {typography: {xs: 'caption', md: 'h6'}, textAlign: 'justify'},
                },
            },
        },
        
        invitation: {
            sectionbody: { 
                frame: {paddingTop: {xs: 1, md: 2}, paddingBottom: {xs: 1, md: 2}},
                image: {justifyContent:'center', marginTop: {xs: 5, md: 10}, marginBottom: {xs: 5, md: 10}},
                imagetitle: {
                    frame: {justifyContent:'center', paddingBottom: {xs: 1, md: 1}},
                    typography: {typography: {xs: 'caption', md: 'h6'}, textAlign: 'center'},
                },
                title: {
                    frame: {justifyContent:'center', paddingBottom: {xs: 1, md: 2}},
                    typography: {typography: {xs: 'subtitle1', md: 'h5'}, textAlign: 'center'},
                },
                content: {
                    frame: {justifyContent:'center', paddingBottom: {xs: 1, md: 2}},
                    typography: {typography: {xs: 'caption', md: 'h6'}, textAlign: 'justify'},
                },
            },

            sectioncover: { 
                frame: {paddingTop: {xs: 1, md: 2}, paddingBottom: {xs: 1, md: 2}},
                imagetitle: {
                    frame: {justifyContent:'right'},
                    typography: {typography: {xs: 'body2', md: 'h5'}, textAlign: 'center', color: 'navy', border: {xs: 2, md: 3}, padding: {xs: 1, md: 2}},
                },
                image: {justifyContent:'center', marginTop: {xs: 15, md: 25}, marginBottom: {xs: 15, md: 25}},
                title: {
                    frame: {justifyContent:'center', paddingBottom: {xs: 1, md: 2}},
                    typography: {typography: {xs: 'subtitle1', md: 'h4'}, textAlign: 'center'},
                },
                content: {
                    frame: {justifyContent:'center', paddingBottom: {xs: 1, md: 2}},
                    typography: {typography: {xs: 'caption', md: 'h6'}, textAlign: 'center'},
                },
            },

            sectionheader: { 
                frame: {paddingTop: {xs: 1, md: 2}, paddingBottom: {xs: 1, md: 2}},
                image: {justifyContent:'center', marginTop: {xs: 5, md: 10}, marginBottom: {xs: 5, md: 10}},
                imagetitle: {
                    frame: {justifyContent:'center', paddingBottom: {xs: 1, md: 1}},
                    typography: {typography: {xs: 'caption', md: 'h6'}, textAlign: 'center'},
                },
                title: {
                    frame: {justifyContent:'center', paddingBottom: {xs: 10, md: 20}},
                    typography: {typography: {xs: 'subtitle1', md: 'h5'}, textAlign: 'center'},
                },
                content: {
                    frame: {justifyContent:'center', paddingBottom: {xs: 1, md: 2}},
                    typography: {typography: {xs: 'caption', md: 'h6'}, textAlign: 'justify'},
                },
            },

            sectionfooter: { 
                frame: {paddingTop: {xs: 1, md: 2}, paddingBottom: {xs: 1, md: 2}},
                image: {justifyContent:'center', marginTop: {xs: 20, md: 40}, marginBottom: {xs: 10, md: 20}},
                imagetitle: {
                    frame: {justifyContent:'center', paddingBottom: {xs: 1, md: 1}},
                    typography: {typography: {xs: 'caption', md: 'h6'}, textAlign: 'center'},
                },
                title: {
                    frame: {justifyContent:'center', paddingBottom: {xs: 10, md: 20}},
                    typography: {typography: {xs: 'subtitle1', md: 'h5'}, textAlign: 'center'},
                },
                content: {
                    frame: {justifyContent:'center', paddingBottom: {xs: 1, md: 2}},
                    typography: {typography: {xs: 'caption', md: 'h6'}, textAlign: 'justify'},
                },
            },
        },

        invoice: {
            ...this.printOption,
            sectionbody: { 
                frame: {paddingTop: {xs: 1, md: 2}, paddingBottom: {xs: 1, md: 2}},
                image: {justifyContent:'center', marginTop: {xs: 5, md: 10}, marginBottom: {xs: 5, md: 10}},
                imagetitle: {
                    frame: {justifyContent:'center', paddingBottom: {xs: 1, md: 1}},
                    typography: {typography: {xs: 'caption', md: 'h6'}, textAlign: 'center'},
                },
                title: {
                    frame: {justifyContent:'center', paddingBottom: {xs: 1, md: 2}},
                    typography: {typography: {xs: 'subtitle1', md: 'h5'}, textAlign: 'center'},
                },
                content: {
                    frame: {justifyContent:'center', paddingBottom: {xs: 1, md: 2}},
                    typography: {typography: {xs: 'caption', md: 'h6'}, textAlign: 'justify'},
                },
            },

            sectioncover: { 
                frame: {paddingTop: {xs: 1, md: 2}, paddingBottom: {xs: 1, md: 2}},
                imagetitle: {
                    frame: {justifyContent:'right'},
                    typography: {typography: {xs: 'body2', md: 'h5'}, textAlign: 'center', color: 'navy', border: {xs: 2, md: 3}, padding: {xs: 1, md: 2}},
                },
                image: {justifyContent:'center', marginTop: {xs: 15, md: 25}, marginBottom: {xs: 15, md: 25}},
                title: {
                    frame: {justifyContent:'center', paddingBottom: {xs: 1, md: 2}},
                    typography: {typography: {xs: 'subtitle1', md: 'h4'}, textAlign: 'center'},
                },
                content: {
                    frame: {justifyContent:'center', paddingBottom: {xs: 1, md: 2}},
                    typography: {typography: {xs: 'caption', md: 'h6'}, textAlign: 'center'},
                },
            },

            sectionheader: { 
                frame: {paddingTop: {xs: 1, md: 2}, paddingBottom: {xs: 1, md: 2}},
                image: {justifyContent:'center', marginTop: {xs: 5, md: 10}, marginBottom: {xs: 5, md: 10}},
                imagetitle: {
                    frame: {justifyContent:'center', paddingBottom: {xs: 1, md: 1}},
                    typography: {typography: {xs: 'caption', md: 'h6'}, textAlign: 'center'},
                },
                title: {
                    frame: {justifyContent:'center', paddingBottom: {xs: 10, md: 20}},
                    typography: {typography: {xs: 'subtitle1', md: 'h5'}, textAlign: 'center'},
                },
                content: {
                    frame: {justifyContent:'center', paddingBottom: {xs: 1, md: 2}},
                    typography: {typography: {xs: 'caption', md: 'h6'}, textAlign: 'justify'},
                },
            },

            sectionfooter: { 
                frame: {paddingTop: {xs: 1, md: 2}, paddingBottom: {xs: 1, md: 2}},
                image: {justifyContent:'center', marginTop: {xs: 20, md: 40}, marginBottom: {xs: 10, md: 20}},
                imagetitle: {
                    frame: {justifyContent:'center', paddingBottom: {xs: 1, md: 1}},
                    typography: {typography: {xs: 'caption', md: 'h6'}, textAlign: 'center'},
                },
                title: {
                    frame: {justifyContent:'center', paddingBottom: {xs: 10, md: 20}},
                    typography: {typography: {xs: 'subtitle1', md: 'h5'}, textAlign: 'center'},
                },
                content: {
                    frame: {justifyContent:'center', paddingBottom: {xs: 1, md: 2}},
                    typography: {typography: {xs: 'caption', md: 'h6'}, textAlign: 'justify'},
                },
            },
        },

        page: {
            sectionbody: { 
                frame: {paddingTop: {xs: 1, md: 2}, paddingBottom: {xs: 1, md: 2}},
                image: {justifyContent:'center', marginTop: {xs: 5, md: 10}, marginBottom: {xs: 5, md: 10}},
                imagetitle: {
                    frame: {justifyContent:'center', paddingBottom: {xs: 1, md: 1}},
                    typography: {typography: {xs: 'caption', md: 'h6'}, textAlign: 'center'},
                },
                title: {
                    frame: {justifyContent:'center', paddingBottom: {xs: 1, md: 2}},
                    typography: {typography: {xs: 'subtitle1', md: 'h5'}, textAlign: 'center'},
                },
                content: {
                    frame: {justifyContent:'center', paddingBottom: {xs: 1, md: 2}},
                    typography: {typography: {xs: 'caption', md: 'h6'}, textAlign: 'justify'},
                },
            },

            sectioncover: { 
                frame: {paddingTop: {xs: 1, md: 2}, paddingBottom: {xs: 1, md: 2}},
                imagetitle: {
                    frame: {justifyContent:'right'},
                    typography: {typography: {xs: 'body2', md: 'h5'}, textAlign: 'center', color: 'navy', border: {xs: 2, md: 3}, padding: {xs: 1, md: 2}},
                },
                image: {justifyContent:'center', marginTop: {xs: 15, md: 25}, marginBottom: {xs: 15, md: 25}},
                title: {
                    frame: {justifyContent:'center', paddingBottom: {xs: 1, md: 2}},
                    typography: {typography: {xs: 'subtitle1', md: 'h4'}, textAlign: 'center'},
                },
                content: {
                    frame: {justifyContent:'center', paddingBottom: {xs: 1, md: 2}},
                    typography: {typography: {xs: 'caption', md: 'h6'}, textAlign: 'center'},
                },
            },

            sectionheader: { 
                frame: {paddingTop: {xs: 1, md: 2}, paddingBottom: {xs: 1, md: 2}},
                image: {justifyContent:'center', marginTop: {xs: 5, md: 10}, marginBottom: {xs: 5, md: 10}},
                imagetitle: {
                    frame: {justifyContent:'center', paddingBottom: {xs: 1, md: 1}},
                    typography: {typography: {xs: 'caption', md: 'h6'}, textAlign: 'center'},
                },
                title: {
                    frame: {justifyContent:'center', paddingBottom: {xs: 10, md: 20}},
                    typography: {typography: {xs: 'subtitle1', md: 'h5'}, textAlign: 'center'},
                },
                content: {
                    frame: {justifyContent:'center', paddingBottom: {xs: 1, md: 2}},
                    typography: {typography: {xs: 'caption', md: 'h6'}, textAlign: 'justify'},
                },
            },

            sectionfooter: { 
                frame: {paddingTop: {xs: 1, md: 2}, paddingBottom: {xs: 1, md: 2}},
                image: {justifyContent:'center', marginTop: {xs: 20, md: 40}, marginBottom: {xs: 10, md: 20}},
                imagetitle: {
                    frame: {justifyContent:'center', paddingBottom: {xs: 1, md: 1}},
                    typography: {typography: {xs: 'caption', md: 'h6'}, textAlign: 'center'},
                },
                title: {
                    frame: {justifyContent:'center', paddingBottom: {xs: 10, md: 20}},
                    typography: {typography: {xs: 'subtitle1', md: 'h5'}, textAlign: 'center'},
                },
                content: {
                    frame: {justifyContent:'center', paddingBottom: {xs: 1, md: 2}},
                    typography: {typography: {xs: 'caption', md: 'h6'}, textAlign: 'justify'},
                },
            },
        },
    }
}